export default __webpack_public_path__ + "2023 Model reduction for molecular diffusion in nanoporous media.pdf";